// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

import { IJSONSchema } from '@glittr/frontend-core/src/plugins/validation/IJSONSchema';
import CompanyRequestSchema from './company-request-schema';
import UserRequestSchema from './user-request-schema';

const schema = {
  $id: '/post-company-request-schema',
  type: 'object',
  required: ['eventIdentifier'],
  properties: {
    accessToken: {
      type: 'string',
      nullable: true,
    },
    company: {
      ...CompanyRequestSchema,
    },
    user: {
      ...UserRequestSchema,
    },
    eventIdentifier: {
      type: 'string',
      format: 'uuid',
    },
    existingCompanyId: {
      type: 'string',
      format: 'uuid',
    },
  },
} as IJSONSchema;

export default schema;
